<template>
  <div id="app" v-loading.fullscreen.lock="loadingApp"
    element-loading-text="拼命加载中..." 
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: function () {
    return {
      // profile: 'dev',
      profile: 'prod',
      authenticated: true,
      userName: '',
      deptName: '',

      modeSelectList: [],

      loadingApp: false,
      showMe: true,

      imgUrl: require(this.global.commonParam.bannerLogo + '.png'),

      collapsed: false,
      leftWidth: '240px',
      rightWidth: 'el-main',
      shrinkstyle: 'menu-toggle',

      shrink: false,
      showshrink: true,

      // dialogFormVisible: false,

      isShow: true,
      functionTitle: '首页',
      // 多标签使用的路由
      route: [],

      // 功能菜单（根据权限加载）
      rightCtrlList: [],

      activeTab: 'default',
      tabList: [{ title: '首页', name: 'default', itemId: '0' }],
      tabCount: 1,
      maxTabCount: 5
    }
  },
  watch: {
    '$route': 'processAccessOut'
  },
  mounted: function () {
    if (this.$route.query.type) {
      this.global.type = this.$route.query.type
    }
    if (this.$route.query.openId) {
      localStorage.openId = this.$route.query.openId
    }
    if (this.$route.query.openid) { // 兼容旧系统
      localStorage.openId = this.$route.query.openid
    }
    this.global.curUser.openId = localStorage.openId || 'xafy'
    // 记录本地存储
    var self = this
    if (process.env.NODE_ENV === 'production') {
      self.axios.all([self.getMode(), self.getUISet()]
      ).then(self.axios.spread(function (mode, uiSet) {
        if (mode.data.result.success === true) {
          self.modeSelectList = mode.data.modeList
          self.global.modeList = mode.data.modeList
          self.global.staticResourceAddr = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '02' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.payUrl = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '08' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.staticUploadAddr = self.modeSelector('Access_URL_Payment').filter(mode => mode.modeId === '07' && mode.field1 === self.global.appTitle)[0].modeValue
          self.global.phoneModeList = mode.data.modeList.filter(mode => mode.typeId === 'Phone_Number_Code_XF')
          self.global.insuranceSet = Number(self.modeSelector('App_Param').filter(mode => mode.modeId === 'Insurance_Set')[0].modeValue)
          self.global.dormConfigSet = Number(self.modeSelector('App_Param').filter(mode => mode.modeId === 'Dorm_Config_Set')[0].modeValue)
        }
        if (uiSet.data.result.success === true) {
          self.global.uiSetItemList = uiSet.data.uiSetItemList
          self.global.uiSetList = uiSet.data.uiSetList
        }
        self.toRoute()
      }))
    } else {
      this.toRoute()
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function () {
      var self = this
      return self.axios.get('/college/getModeByTypeList', { params: { typeList: self.global.typeIdList } })
    },
    // 加载界面配置
    getUISet: function (uiSetIdList) {
      var self = this
      return self.axios.get('/college/getUISetItemByIDList', { params: { setIdList: self.global.uiSetIdList } })
    },
    // 根据当前机构Id和活动标签获取需要加载的页面
    getPageByDeptId: function (type) {
      return this.global.pageMap.filter(element => element.type === type)
    },
    // 标签点击事件
    toRoute: function () {
      let pageItem = this.getPageByDeptId(this.global.type)
      if (pageItem.length > 0) {
        document.title = pageItem[0].title
        this.$router.push('/' + pageItem[0].pageName)
        this.route = [{ path: '/' + pageItem[0].pageName, component: require('./components/' + pageItem[0].pageUrl + '.vue'), meta: { title: pageItem[0].title } }]
        this.$router.addRoutes(this.route)
      }
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      return this.modeSelectList.filter(function (element) {
        return element.typeId === typeId
      })
    },
    // 处理外部访问
    processAccessOut: function () {
      if (this.$route.path === '/') {
        this.toRoute()
      }
    }
  }
}
</script>

<style>
  .el-main {
    /* width: 60%; */
    /* margin-left: 240px; */
    text-align: left;
    margin-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5cd0dd80